// @ts-check

import React from "react";


export default class SchedulerOperationsGridRefs {

  /** @type {React.MutableRefObject<number | null>} */
  static lastClickedItemRowIndexRef = React.createRef();




}



